import {
  SnippetElement,
  defineElement
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-search-popover/common-search-popover.ts
var CommonSearchPopover = class extends SnippetElement {
  /*
    private baseUrl: string = `${(window as any)?.Shopify?.routes?.root}`
  
    @query('[data-output]')
    output!: HTMLDivElement
  
    @query('[data-loading]')
    loadingIcon!: HTMLDivElement
  
    @query('[data-predictive-search]')
    predictiveSearch!: HTMLInputElement
  
    @query('[data-search-backdrop]')
    searchBackdrop!: HTMLDivElement
  
    @query('[data-close-output]')
    closeOutput!: HTMLDivElement
  
    @param()
    time?: number
  
    @query('[search-popover]')
    private searchPopover!: UtilPopover
  
    @globalOn('cart:open')
    async closeSearchModal () {
      this.searchPopover?.close()
      this.searchBackdrop?.classList.add('opacity-0')
      await wait(100)
      if(!this.searchPopover?.isOpen) {
        this.searchBackdrop?.classList.add('hidden')
        this.closeOutput.classList.add('hidden')
        document.body.removeAttribute('scroll-lock')
      } else {
        this.openSearchModal()
      }
    }
    
    async openSearchModal () {
      this.searchPopover?.open()
      document.body.setAttribute('scroll-lock', '')
      this.searchBackdrop?.classList.remove('hidden')
      this.closeOutput.classList.remove('hidden')
      await wait(1)
      this.searchBackdrop?.classList.remove('opacity-0')
    }
  
    get loading() {
      return this.loadingIcon?.classList.contains('hidden') ?? false
    }
  
    set loading(val: boolean) {
      if (val) {
        this.loadingIcon?.classList.remove('hidden')
      } else {
        this.loadingIcon?.classList.add('hidden')
      } 
    }
    
    debouncedRender = Debounce.debounce(() => {
      this.fetchPredictiveSearch()
    }, this.time ?? 800)
  
    connectedCallback() {
      document.addEventListener('click', (event: any) => {
        if (!this.searchPopover.contains(event.target) && !this.predictiveSearch.contains(event.target) && event.target.getAttribute('data-focus-mobile-search') == null) {
          this.closeSearchModal()
        }
      })
    }
    
    @on('click', '[data-predictive-search]')
    handleClick() {
      if(!this.searchPopover?.isOpen && this.predictiveSearch?.value != '') {
        this.openSearchModal()
      }
    }
  
    @on('input', '[data-predictive-search]')
    handleInput() {
      
      if(this.predictiveSearch?.value == '') {
        this.closeSearchModal()
      } else {
        this.loading = true
        this.output!.innerHTML = ''
        this.openSearchModal()
        this.debouncedRender()
      }
    }
  
    @onClick('[data-close-output]')
    @onClick('[data-input-reset]')
    async resetInput() {
      this.predictiveSearch.value = ''
      this.closeSearchModal()
      this.output!.innerHTML = ''
    }
  
    async fetchPredictiveSearch() {
      const response = await fetch(`${this.baseUrl}search/suggest?q=${this.predictiveSearch?.value}&resources[type]=article,product,collection,page&section_id=ajax-search`)
      if (response.status == 422) {
        this.loading = false
        return
      }
      const text = await response.text()
      const html = document.createElement('div')
      html.innerHTML = text
      if (this.output) {
        this.output.innerHTML = html.innerHTML
      }
      GlobalEvents.emit('recommendation:performed')
      this.loading = false
    }*/
};
CommonSearchPopover = __decorateClass([
  defineElement()
], CommonSearchPopover);
export {
  CommonSearchPopover
};
